import React from 'react'

const iconBase = (fill, children) => (
  <svg width="40" height="40" fill="none" viewBox="0 0 40 40" aria-hidden="true">
    <rect width="40" height="40" rx="12" fill={fill} />
    {children}
  </svg>
)

export const services = [
  {
    id: 'product-development',
    title: 'Product Development',
    blurb:
      'From discovery through launch: we design, build, and ship software products so you can move from idea to users without standing up a full engineering team.',
    detail:
      'We partner on product strategy, UX, architecture, and delivery. Engagements cover MVP builds, feature expansion, and ongoing product engineering — with clear milestones and ownership from kickoff to production.',
    icon: iconBase(
      '#3078a8',
      <>
        <path
          d="M13 27v-7a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v7"
          stroke="#fff"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <circle cx="20" cy="16" r="4" stroke="#fff" strokeWidth="2" />
      </>
    ),
  },
  {
    id: 'digital-software',
    title: 'Digital & Software',
    blurb:
      'Custom web and mobile applications built for the workflows your customers and teams actually use — reliable, maintainable, and ready to scale.',
    detail:
      'We deliver full-stack applications, APIs, and integrations with a focus on clean architecture and measurable outcomes. Suitable for customer-facing products, internal tools, and platform work that sits alongside FinQ-style systems.',
    icon: iconBase(
      '#54b4f0',
      <path d="M13 27h14M20 13v14" stroke="#fff" strokeWidth="2" strokeLinecap="round" />
    ),
  },
  {
    id: 'cloud',
    title: 'Cloud',
    blurb:
      'Cloud architecture, migration, and operations that keep your workloads available, cost-aware, and straightforward to run day to day.',
    detail:
      'We design and implement cloud environments on major providers: infrastructure as code, CI/CD, observability, and hardening. Whether you are lifting an existing stack or building greenfield, we keep the setup lean and documented.',
    icon: iconBase(
      '#18546c',
      <path
        d="M28 24a4 4 0 0 0-3.8-4A5 5 0 0 0 10 21a4 4 0 0 0 1 7.9h16A3 3 0 0 0 28 24Z"
        stroke="#fff"
        strokeWidth="2"
        strokeLinejoin="round"
      />
    ),
  },
  {
    id: 'data-analytics',
    title: 'Data & Analytics',
    blurb:
      'Pipelines, dashboards, and decision tooling so your team works from timely, trustworthy data instead of spreadsheets and guesswork.',
    detail:
      'We build data ingestion, warehousing, and reporting layers — including alert and insight flows similar to what powers FinQ. From one-off analysis pipelines to ongoing BI, we match scope to the decisions you need to make.',
    icon: iconBase(
      '#3078a8',
      <path d="M14 26v-6m6 6v-10m6 10v-4" stroke="#fff" strokeWidth="2" strokeLinecap="round" />
    ),
  },
]
